import { useQuery, useQueryClient } from '@tanstack/react-query';
import { gql, apiLogout } from './api';
import { clearSession } from './accounts';

export interface Me {
  id: string;
  name: string;
  email: string;
  pictureUrl: string | null;
  linkedinUrl: string | null;
  linkedinUrlVerified: boolean;
  isAdmin: boolean;
}

const ME_QUERY = /* GraphQL */ `
  query Me {
    me {
      id
      name
      email
      pictureUrl
      linkedinUrl
      linkedinUrlVerified
      isAdmin
    }
  }
`;

const AUTH_ME_KEY = ['auth', 'me'] as const;

export function useMe() {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: AUTH_ME_KEY,
    queryFn: async () => {
      const data = await gql.request<{ me: Me | null }>(ME_QUERY);
      return data.me;
    },
  });

  async function logout() {
    await apiLogout();
    clearSession();
    qc.setQueryData(AUTH_ME_KEY, null);
    // Module-level `['me']` consumers share a different key — clear that too
    // so sidebars/bells flip back to the logged-out state immediately.
    qc.setQueryData(['me'], null);
    window.location.href = '/';
  }
  return { ...q, logout };
}
